export const VERSION = '4.40.0';
